import { erpApi } from "@/shared/axios/erp-api";
import { urlBackend } from "@/shared/constants";
import {
  FotosTrasladoSnapshot,
  useFotosTrasladoLive,
} from "@/erp/tecnico/orden-trabajo/shared/components/tables/fotos/traslado/fotos-traslado.actions";
import { ExcedenteFibra, excedenteFibraDe } from "./excedente-fibra.utils";

/**
 * API del excedente de fibra del traslado. El backend calcula los montos y
 * devuelve el "estado en vivo" del traslado (el mismo del sondeo de fotos), que
 * se escribe en caché para que la otra pantalla lo vea sin recargar.
 */
const { post } = erpApi();

const urlExcedente = (idOrdenTrabajo: string) =>
  `${urlBackend}api/v1/orden-trabajo/${idOrdenTrabajo}/excedente-fibra/`;

/** Técnico: registra los metros de excedente (0 = quitar). */
export async function registrarExcedenteFibra(
  idOrdenTrabajo: string,
  metros: number,
): Promise<FotosTrasladoSnapshot> {
  const res = await post<FotosTrasladoSnapshot>(`${urlExcedente(idOrdenTrabajo)}registrar/`, { metros }, true);
  return res.data;
}

/** Activaciones: valida metros, define precio y forma de pago, y aprueba. */
export async function aprobarExcedenteFibra(
  idOrdenTrabajo: string,
  body: {
    metros?: number;
    precio_metro_sin_iva?: number;
    tipo_pago?: string | null;
    meses_pago?: number | null;
  },
): Promise<FotosTrasladoSnapshot> {
  const res = await post<FotosTrasladoSnapshot>(`${urlExcedente(idOrdenTrabajo)}aprobar/`, body, true);
  return res.data;
}

/**
 * Excedente de fibra EN VIVO de una OT de traslado: toma el del sondeo y, hasta
 * que llegue la primera respuesta, el que vino con la OT. Así el técnico ve la
 * aprobación (y Activaciones el registro) sin recargar la página.
 */
export function useExcedenteFibraLive(ordenTrabajo: any, enabled = true) {
  const id = ordenTrabajo?.id_orden_trabajo as string | undefined;
  const { data: snapshot, isFetched } = useFotosTrasladoLive(id, enabled);
  const enVivo = enabled && isFetched && !!snapshot && `${snapshot.id_orden_trabajo}` === `${id}`;
  const excedente: ExcedenteFibra | null = enVivo
    ? ((snapshot?.excedente_fibra as ExcedenteFibra | null | undefined) ?? null)
    : excedenteFibraDe(ordenTrabajo?.agendamiento_data?.observaciones);
  return { excedente, enVivo };
}
